// Help's tick box, as the mock draws it: a slate outline, cyan when ticked,
// with the tick drawn over it. The browser's own box is white on the dark
// console.

import { CheckIcon } from '@heroicons/react/24/outline';

const box = 'peer h-6 w-6 shrink-0 cursor-pointer appearance-none rounded-[6px] border-2 border-slate-500 bg-transparent checked:border-cyan-500 checked:bg-cyan-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900';

export function TickBox({ checked, onChange, label, className = '' }: { checked: boolean; onChange: (on: boolean) => void; label?: string; className?: string }) {
  return (
    <span className={`relative flex shrink-0 ${className}`}>
      <input type="checkbox" aria-label={label} className={box} checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <CheckIcon className="pointer-events-none absolute inset-1 hidden h-4 w-4 stroke-[3] text-slate-950 peer-checked:block" aria-hidden="true" />
    </span>
  );
}
